import React, { useEffect, useState } from 'react';
import './preview-manager-landing.styles.scss';
import { previewGameData, previewUserContent } from '../previewGameData';
import { Desktop, LargeTablet, Mobile, Tablet } from '@/utils/responsiveQueries';
import ManageHeadBar from '@/components/MANAGE-GAME/manage-layout/manage-game-head-bar/manage-head-bar.component';
import ManageGameSidebar from '@/components/MANAGE-GAME/manage-layout/manage-game-sidebar/manage-game-sidebar.component';
import ManageLanding from '@/components/MANAGE-GAME/manage-landing.component';
import ManageMobileHeader from '@/components/MANAGE-GAME/manage-layout/manage-game-head-bar/manage-mobile-head.component';
import Loader from '@/components/loader/loader.comp';
import PreviewBorder from '../preview-border/preview-border.component';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentUser, setMembership, setUserProfile } from '@/state/slices/userSlice';
import { useNavigate } from 'react-router-dom';
import { ModalAlert } from '@/components/modal/modal.component';

const PreviewManagerLanding = () => {

  const currentUser = useSelector(state => state.userData.currentUser);
  const [ currentGame, setCurrentGame ] = useState(previewGameData.gameData);
  const [ actionItems, setActionItems ] = useState({});
  const [ gameElements, setGameElements ] = useState({});
  const [ playerList, setPlayerList ] = useState({});
  const [ orgs , setOrgs ] = useState({});
  const [ role, setRole ] = useState('manager');
  const [ defaultActivityRecords, setDefaultActivityRecords ] = useState({});
  const [ gameStats, setGameStats ] = useState({});
  const [ teamMembers, setTeamMembers ] = useState({});
  const [ passcodes, setPasscodes ] = useState({});
  const [ latestMessage, setLatestMessage ] = useState({});
  const [ gameManagers, setGameManagers ] = useState([]);
  const [ activityCounts, setActivityCounts ] = useState({});
  const [ alertMessage, setAlertMessage ] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) return;
    if (currentUser.uid !== "preview-manager") {
      navigate('/logout?redirectUrl=/preview/manager/previewgame'); 
    }
  }, [currentUser])

  useEffect(() => {
    if (!currentGame) return;
    document.title = `Gamably Preview Game Manager`;
    const r = document.querySelector(':root');
    r.style.setProperty('--primary', currentGame.color);
    r.style.setProperty('--primary-trans', currentGame.color+'a6');
  }, [currentGame]);
  
  useEffect(() => {
    if (!previewUserContent) return;
    dispatch(setCurrentUser(previewUserContent.currentUser)),
    dispatch(setMembership(previewUserContent.membership)),
    dispatch(setUserProfile(previewUserContent.userProfile))
  }, [previewUserContent]);

  function changeActionItemStatus() {
    setAlertMessage('Sorry! Data cannot be changed in Preview Mode.');
    return;
  }

  return (
    <div className='preview-manager-landing'>
      
        {
            (currentGame) 
            ?
            <div className='manage-game-page' style={
                (currentGame.bg.type === 'gradient')
                ?
                {'background': `linear-gradient(to bottom, ${currentGame.bg.hexTop}, ${currentGame.bg.hexBottom})`}
                :
                {'backgroundImage': `url("${currentGame.bg.url}")`}
            }>
                <Desktop>
                    <ManageHeadBar gameData={currentGame} />
                    <div className='manage-content'>
                        <ManageGameSidebar 
                            gameData={currentGame} 
                            actionItems={actionItems} 
                            gameElements={gameElements}
                            playerList={playerList}
                            orgs={orgs}
                            role={role}
                        />
                        <ManageLanding 
                            gameData={currentGame} 
                            gameElements={gameElements} 
                            playerList={playerList} 
                            defaultActivityRecords={defaultActivityRecords} 
                            gameStats={gameStats}
                            actionItems={actionItems}
                            changeActionItemStatus={changeActionItemStatus}
                            teamMembers={teamMembers}
                            passcodes={passcodes}
                            latestMessage={latestMessage}
                            gameManagers={gameManagers}
                            activityCounts={activityCounts}
                            orgs={orgs}
                            role={role}
                        />
                    </div>
                </Desktop>
                
                <LargeTablet>
                    <ManageMobileHeader 
                        gameData={currentGame}
                        gameElements={gameElements}
                        playerList={playerList}
                        orgs={orgs}
                        role={role} />
                    {/* <div className='manage-content'> */}
                        {/* <ManageGameSidebar 
                            gameData={currentGame} 
                            actionItems={actionItems} 
                            gameElements={gameElements}
                            orgs={orgs}
                            role={role}
                        /> */}
                        <ManageLanding 
                            gameData={currentGame} 
                            gameElements={gameElements} 
                            playerList={playerList} 
                            defaultActivityRecords={defaultActivityRecords} 
                            gameStats={gameStats}
                            actionItems={actionItems}
                            changeActionItemStatus={changeActionItemStatus}
                            teamMembers={teamMembers}
                            passcodes={passcodes}
                            latestMessage={latestMessage}
                            gameManagers={gameManagers}
                            activityCounts={activityCounts}
                            orgs={orgs}
                            role={role}
                        />
                    {/* </div> */}
                </LargeTablet>

                <Tablet>
                    <ManageMobileHeader 
                        gameData={currentGame}
                        gameElements={gameElements}
                        playerList={playerList}
                        actionItems={actionItems}
                        orgs={orgs}
                        role={role} />
                    <ManageLanding 
                        gameData={currentGame} 
                        gameElements={gameElements} 
                        playerList={playerList} 
                        defaultActivityRecords={defaultActivityRecords} 
                        gameStats={gameStats}
                        actionItems={actionItems}
                        changeActionItemStatus={changeActionItemStatus}
                        teamMembers={teamMembers}
                        passcodes={passcodes}
                        latestMessage={latestMessage}
                        gameManagers={gameManagers}
                        activityCounts={activityCounts}
                        orgs={orgs}
                        role={role} />
                </Tablet>

                <Mobile>
                    <ManageMobileHeader 
                        gameData={currentGame}
                        gameElements={gameElements}
                        actionItems={actionItems}
                        playerList={playerList}
                        orgs={orgs}
                        role={role} />
                    <ManageLanding 
                        gameData={currentGame} 
                        gameElements={gameElements} 
                        playerList={playerList} 
                        defaultActivityRecords={defaultActivityRecords} 
                        gameStats={gameStats}
                        actionItems={actionItems}
                        changeActionItemStatus={changeActionItemStatus}
                        teamMembers={teamMembers}
                        passcodes={passcodes}
                        latestMessage={latestMessage}
                        gameManagers={gameManagers}
                        activityCounts={activityCounts}
                        orgs={orgs}
                        role={role} />
                </Mobile>
            </div>
            :
            <div className='loading-page'>
                <Loader />
            </div>
        }
        <ModalAlert
          show={!!alertMessage}
          cancel={() => setAlertMessage(null)}
          message={alertMessage} />
        <PreviewBorder />
    </div>
  )
}

export default PreviewManagerLanding